import Vue from 'vue'
import configs from '@/config'
import VTooltip from 'v-tooltip'

// storybook
import AhaAudience from '@mindthegapstudio/stpancras-storybook-app/src/AhaAudience'

// Sentry
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

// Vue Click Outside
import vClickOutside from 'v-click-outside'

// Filter
import '@/filters'

// Vue resources
import VueResource from 'vue-resource'

// plugins
import functionsPlugin from '@/plugins/functions'

// Vue dialog
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// Vue Toasted
import Toasted from 'vue-toasted'
import store from './store'
import i18n from './i18n'
import router from './router'

import '@/assets/scss/normalize.scss'
import '@/assets/scss/animate2.css'
import '@/assets/scss/iconAnimate.scss'
import '@/assets/scss/dialog.scss'
import '@/assets/scss/checkbox.scss'
import '@/assets/css/font-awesome.min.css'
import '@/assets/scss/flex.scss'
import '@/assets/scss/variables.scss'
import '@/assets/scss/base.scss'
import '@/assets/scss/global.scss'
import '@/assets/fontawesome/css/all.css'

import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

import 'emoji-mart-vue-fast/css/emoji-mart.css'

import App from './App.vue'

Vue.config.productionTip = false

const ignoreErrors = [
  'ResizeObserver loop limit exceeded',
  'zaloJSV2 is not defined',
  'Can\'t find variable: zaloJSV2',
  'Cannot read property \'getReadModeConfig\' of undefined',
  'Cannot read property \'getReadModeRender\' of undefined',
  'Cannot read property \'getReadModeExtract\' of undefined',
]

if (configs.isSentryEnabled) {
  Sentry.init({
    release: configs.sentryRelease,
    dsn: configs.sentry,
    environment: configs.env,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    Vue,
    tracingOptions: {
      trackComponents: true,
    },
    beforeSend(event) { // https://github.com/getsentry/sentry-docs/issues/1137#issuecomment-610404004
      if (event && event.message && ignoreErrors.includes(event.message)) {
        return null
      }
      return event
    },
    ignoreErrors,
  })
}

// use custom plugins
Vue.use(functionsPlugin)

// use v-tooltip
Vue.use(VTooltip, {
  defaultOffset: 8,
  defaultTrigger: 'hover click',
})

// use storybook
Vue.use(AhaAudience)

Vue.use(vClickOutside)
Vue.use(VueResource)
Vue.use(VuejsDialog)
Vue.use(Toasted, {
  duration: 3000,
  singleton: true,
})

// eslint-disable-next-line import/prefer-default-export
export const app = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
